import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/no-access")({
  head: () => ({
    meta: [
      { title: "Acesso ainda não liberado — Projeto 101" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: NoAccessPage,
});

function NoAccessPage() {
  const navigate = useNavigate();
  async function signOut() {
    await supabase.auth.signOut();
    navigate({ to: "/auth", replace: true });
  }
  return (
    <div className="min-h-screen bg-[var(--beige)] font-body text-[var(--navy)]">
      <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center px-6 py-10 text-center">
        <h1 className="font-display text-3xl font-extrabold">Seu acesso ainda não foi liberado</h1>
        <p className="mt-3 text-[var(--gray-ink)]">
          Sua conta existe, mas ainda não há um acesso ativo ao produto{" "}
          <strong>101 Negócios Reais</strong>. Assim que a compra for confirmada, o acesso é liberado
          automaticamente.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to={"/checkout" as never}
            className="rounded-md bg-[var(--navy)] px-5 py-2 text-sm font-semibold text-white shadow-[0_10px_24px_-10px_rgba(12,27,51,0.6)] transition hover:scale-[1.02]"
          >
            Concluir pagamento (R$ 47)
          </Link>
          <Link
            to="/"
            className="rounded-md border border-black/10 px-4 py-2 text-sm font-semibold"
          >
            Voltar à landing
          </Link>
          <button
            onClick={signOut}
            className="rounded-md border border-black/10 px-4 py-2 text-sm font-semibold"
          >
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}
